<div class="min-h-screen xl:flex">
  @if (!isStandaloneCalendarPage()) {
    <div>
      <app-sidebar></app-sidebar>
      <app-backdrop></app-backdrop>
    </div>
  }
  <div
    class="min-w-0 flex-1 transition-all duration-300 ease-in-out"
    [ngClass]="{
      'xl:ml-[290px]': !isStandaloneCalendarPage() && (isExpanded$ | async),
      'xl:ml-[90px]': !isStandaloneCalendarPage() && !(isExpanded$ | async),
      'ml-0': isStandaloneCalendarPage() || (isMobileOpen$ | async),
    }"
  >
    @if (!isStandaloneCalendarPage()) {
      <!-- app header start -->
      <app-header />
      <!-- app header end -->
    }
    <div class="mx-auto w-full min-w-0 p-4 md:p-6">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
